/**
 * Vertrag der Laufzeit-Einstellungen des LLM-Gateways (AP2.T2.6).
 *
 * Diese Werte liegen in der `config`-Tabelle und werden ueber die Oberflaeche
 * unter Einstellungen gesetzt. Sie wirken **ab dem naechsten Aufruf**, ohne
 * Neustart. Fachliche Einstellungen (Lernschwellen, Timer) gehoeren nicht
 * hierher - hier geht es ausschliesslich um Provider, Modell und die
 * Aufrufparameter.
 */
/** Zur Auswahl stehende Modelle. Bewusst kurz gehalten statt Freitext. */
export const LLM_MODEL_CHOICES = [
    { id: 'claude-opus-5', label: 'Opus 5 - staerkstes Modell, teuerste Aufrufe' },
    { id: 'claude-sonnet-5', label: 'Sonnet 5 - Standard fuer die meisten Aufgaben' },
    { id: 'claude-haiku-4-5', label: 'Haiku 4.5 - schnell und guenstig, fuer einfache Aufgaben' },
];
export const LLM_MODEL_IDS = LLM_MODEL_CHOICES.map((choice) => choice.id);
export function isLlmModelId(value) {
    return typeof value === 'string' && LLM_MODEL_IDS.includes(value);
}
/** Zulaessige Spanne je Zahlenfeld - Grundlage der serverseitigen Pruefung. */
export const LLM_SETTINGS_RANGES = {
    /**
     * Ein Vision-Aufruf aus AP3 braucht deutlich mehr als ein Textaufruf.
     *
     * Obergrenze in T3.3 von 600 000 auf 1 800 000 ms angehoben: Der
     * Kalibrierungslauf zeigte, dass `claude-sonnet-5` bei den dichtesten
     * 13x13-Rastern die 600 s reisst (4 von 8 Charts der Stichprobe), waehrend
     * dieselben Charts bei `claude-haiku-4-5` in unter 200 s durchlaufen. Ohne
     * Luft nach oben waere die Modellwahl nicht durch Qualitaet, sondern durch
     * eine Zeitgrenze entschieden (ADR-0033).
     */
    timeoutMs: { min: 5_000, max: 1_800_000 },
    /** Der Host ist geteilt; mehr als eine Handvoll CLI-Prozesse waere unfair. */
    maxConcurrency: { min: 1, max: 8 },
    /** Mehr Versuche verbrennen bei echter Stoerung nur Kontingent. */
    maxAttempts: { min: 1, max: 10 },
};
export function isLlmSettingsErrorResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const candidate = value;
    return candidate['error'] === 'invalid_settings' && Array.isArray(candidate['fields']);
}
/** Der Prompt des Ping-Tests. Bewusst winzig - er kostet echtes Kontingent. */
export const LLM_PING_PROMPT = 'Antworte nur mit OK';
//# sourceMappingURL=settings.js.map